// Localized name of an installation-type option.
export function installTypeName(opt, lang) {
  if (!opt) return "";
  return (
    (opt[`name_${lang}`] || "").trim() ||
    (opt.name_nl || "").trim() ||
    (opt.name_en || "").trim() ||
    (opt.name_fr || "").trim() ||
    (opt.name_de || "").trim()
  );
}

// Localized one-line explanation of an installation-type option (falls back to NL source).
export function installTypeDesc(opt, lang) {
  if (!opt) return "";
  return (opt[`desc_${lang}`] || "").trim() || (opt.desc_nl || "").trim();
}

// Localized product content. Dutch (base fields) is the single source; en/fr/de come
// from AI translations stored in product.translations. Everything falls back to Dutch.
export function productName(product, lang) {
  if (!product) return "";
  const tr = product.translations?.[lang]?.name;
  if (tr && tr.trim()) return tr;
  return product.name || "";
}

export function productField(product, lang, field) {
  if (!product) return "";
  const tr = product.translations?.[lang];
  if (tr && tr[field] != null && String(tr[field]).trim()) return tr[field];
  return product[field] || "";
}

// Localized specifications — only use the translated set when it matches the source structure.
export function productSpecs(product, lang) {
  const base = product?.specifications || [];
  const tr = product?.translations?.[lang]?.specifications;
  if (Array.isArray(tr) && tr.length === base.length && tr.length) return tr;
  return base;
}

// Combined manuals list with automatic fallback to the legacy single manual fields.
export function getManuals(product) {
  const list = Array.isArray(product?.manuals) ? product.manuals.filter((m) => m && m.url) : [];
  if (list.length) return list;
  const legacy = [];
  if (product?.manual_url) legacy.push({ type: "pdf", url: product.manual_url });
  if (product?.manual_3d_url) legacy.push({ type: "3d", url: product.manual_3d_url });
  return legacy;
}

// Localized manual title. Dutch base `title`; en/fr/de come from title_en/fr/de (Translate).
export function manualTitle(m, lang, fallback) {
  if (!m) return fallback || "";
  const base = (m.title || "").trim();
  if (lang === "nl") return base || (m.title_nl || "").trim() || fallback || "";
  return (m[`title_${lang}`] || "").trim() || base || fallback || "";
}

// Localized tags — use the translated set when it matches the source length, else the base.
export function productTags(product, lang) {
  const base = (product?.tags || []).filter(Boolean);
  const tr = product?.translations?.[lang]?.tags;
  if (Array.isArray(tr) && tr.length === base.length && tr.length) return tr.filter(Boolean);
  return base;
}

